import { useEffect, useState } from 'react';

export const useTheme = () => {
  // Por defecto usamos 'dark' en lugar de 'light'
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('theme') || 'dark';
  });

  useEffect(() => {
    // Aplicar tema al elemento html (root) para que afecte las variables CSS
    document.documentElement.setAttribute('data-theme', theme);
    // También al body por compatibilidad
    document.body.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
  };

  return { theme, toggleTheme };
};
